"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var eventsource_1 = require("eventsource");
var axios_1 = require("axios");
var axios_retry_1 = require("axios-retry");
/**
 *  !IMPORTANT this script is used in a command line script
 *  Therefore, DO NOT use console.log() statements unless it is wrapped in a condition checking the logToConsole property.
 *  Otherwise, you will break CLI usage that the test runner depends on
 **/
var Openai = /** @class */ (function () {
    function Openai(type, assistantId, recordId, pageId) {
        if (type === void 0) { type = null; }
        if (assistantId === void 0) { assistantId = null; }
        if (recordId === void 0) { recordId = null; }
        if (pageId === void 0) { pageId = null; }
        var _this = this;
        this.threadId = null;
        this.assistantId = null;
        this.runId = null;
        this.baseUrl = '';
        this.type = null;
        this.recordId = null;
        this.pageId = null;
        this.instructions = '';
        this.runStatus = null;
        this.feedback = '';
        this.grade = null;
        this.aiScoreFailed = false;
        this.completedRunIds = [];
        this.scoringPollTimer = null;
        this.feedbackPollTimer = null;
        this.aborted = false;
        this.abortController = new AbortController();
        this.functionCallsHandled = false;
        this.eventSource = null;
        this.apiToken = '';
        this.outputFormat = 'text';
        this.logToConsole = false;
        this.setInstructions = function (instructions_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([instructions_1], args_1, true), void 0, function (instructions, replacementTokens, promptKey) {
                if (replacementTokens === void 0) { replacementTokens = null; }
                if (promptKey === void 0) { promptKey = null; }
                return __generator(this, function (_a) {
                    this.instructions = instructions;
                    // Make API call to update instructions in database
                    // @ts-ignore
                    (0, axios_retry_1.default)(axios_1.default, {
                        retries: 3,
                        retryCondition: function () { return true; },
                        retryDelay: function (retryCount) {
                            return retryCount * 1000;
                        }
                    });
                    axios_1.default.post("".concat(this.baseUrl, "/api/openai/thread/").concat(this.threadId, "/instructions"), {
                        instructions: instructions,
                        replacement_tokens: replacementTokens,
                        prompt_key: promptKey
                    }).catch(function (error) {
                        console.error('Error updating thread instructions:', error);
                    });
                    return [2 /*return*/];
                });
            });
        };
        this.getScoringAssistants = function () { return __awaiter(_this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // @ts-ignore
                        (0, axios_retry_1.default)(axios_1.default, {
                            retries: 3, retryCondition: function () { return true; }, retryDelay: function (retryCount) {
                                return retryCount * 1000;
                            }
                        });
                        return [4 /*yield*/, axios_1.default.get("//".concat(window.location.hostname, "/api/openai/assistant/?type=scoring"))];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.data];
                }
            });
        }); };
        this.getScoringAssistantById = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // @ts-ignore
                        (0, axios_retry_1.default)(axios_1.default, {
                            retries: 3, retryCondition: function () { return true; }, retryDelay: function (retryCount) {
                                return retryCount * 1000;
                            }
                        });
                        return [4 /*yield*/, axios_1.default.get("//".concat(window.location.hostname, "/api/openai/assistant/").concat(id))];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.data];
                }
            });
        }); };
        this.getAssistantsByType = function (type) { return __awaiter(_this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // @ts-ignore
                        (0, axios_retry_1.default)(axios_1.default, {
                            retries: 3, retryCondition: function () { return true; }, retryDelay: function (retryCount) {
                                return retryCount * 1000;
                            }
                        });
                        return [4 /*yield*/, axios_1.default.get("//".concat(window.location.hostname, "/api/openai/assistant/?type=").concat(type))];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.data];
                }
            });
        }); };
        this.extractTextFromResponse = function (text) {
            var _a, _b;
            if (_this.outputFormat === 'json_schema') {
                var json = JSON.parse(text);
                if (_this.logToConsole) {
                    console.log(json);
                }
                return (_a = json.text) !== null && _a !== void 0 ? _a : 'No text property is configured in json_schema';
            }
            else if (_this.outputFormat === 'text') {
                // eventually all assistants should be converted to json_schema
                // this is also to handle backwards compatability for polling
                try {
                    var json = JSON.parse(text);
                    if (_this.logToConsole) {
                        console.log(json);
                    }
                    return (_b = json.text) !== null && _b !== void 0 ? _b : text;
                }
                catch (error) {
                    if (_this.logToConsole) {
                        console.log(text);
                    }
                    return text;
                }
            }
            else {
                return text;
            }
        };
        this.type = type;
        this.recordId = recordId;
        this.pageId = pageId;
        this.assistantId = assistantId;
        if (typeof window !== 'undefined') {
            this.baseUrl = '//' + window.location.hostname;
            // @ts-ignore
            this.apiToken = window.apiToken;
            axios_1.default.defaults.headers.common['x-api-token'] = this.apiToken;
        }
    }
    Openai.prototype.abortOperations = function () {
        this.aborted = true;
        this.killFeedbackPollTimer();
        this.killScoringPollTimer();
        this.abortController.abort();
        this.abortController = new AbortController(); // Reset for future operations
    };
    Openai.prototype.stripHtml = function (html) {
        return html.replace(/<[^>]*>?/g, '');
    };
    Openai.prototype.setBaseUrl = function (url) {
        this.baseUrl = url;
    };
    Openai.prototype.setAPIToken = function (token) {
        this.apiToken = token;
        axios_1.default.defaults.headers.common['x-api-token'] = this.apiToken;
    };
    Openai.prototype.setMessagesCallback = function (callback) {
        // @ts-ignore
        this.getMessagesCallback = callback;
    };
    Openai.prototype.setScoreCallback = function (callback) {
        // @ts-ignore
        this.getScoreCallback = callback;
    };
    Openai.prototype.createThread = function () {
        return __awaiter(this, void 0, void 0, function () {
            var resp, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        // @ts-ignore
                        (0, axios_retry_1.default)(axios_1.default, {
                            retries: 3, retryCondition: function () { return true; }, retryDelay: function (retryCount) {
                                return retryCount * 1000;
                            }
                        });
                        return [4 /*yield*/, axios_1.default.post("".concat(this.baseUrl, "/api/openai/thread"), {
                                type: this.type,
                                record_id: this.recordId,
                                page_id: this.pageId
                            })];
                    case 1:
                        resp = _a.sent();
                        this.threadId = resp.data.id;
                        return [2 /*return*/, true];
                    case 2:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Openai.prototype.addMessageToThread = function (content_1) {
        return __awaiter(this, arguments, void 0, function (content, runAssistant, role) {
            var e_2;
            if (runAssistant === void 0) { runAssistant = true; }
            if (role === void 0) { role = 'user'; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        // @ts-ignore
                        (0, axios_retry_1.default)(axios_1.default, {
                            retries: 3, retryCondition: function () { return true; }, retryDelay: function (retryCount) {
                                return retryCount * 1000;
                            }
                        });
                        return [4 /*yield*/, axios_1.default.post("".concat(this.baseUrl, "/api/openai/thread/").concat(this.threadId, "/message"), {
                                role: role,
                                content: this.stripHtml(content),
                                signal: this.abortController.signal
                            })];
                    case 1:
                        _a.sent();
                        if (!runAssistant) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.runAssistant()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        e_2 = _a.sent();
                        if (e_2.name === 'AbortError') {
                            console.error('addMessageToThread was aborted');
                        }
                        else {
                            console.error(e_2);
                        }
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Openai.prototype.runAssistant = function () {
        return __awaiter(this, void 0, void 0, function () {
            var runs, inProgress, data, resp, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        // @ts-ignore
                        (0, axios_retry_1.default)(axios_1.default, {
                            retries: 3, retryCondition: function () { return true; }, retryDelay: function (retryCount) {
                                return retryCount * 1000;
                            }
                        });
                        return [4 /*yield*/, axios_1.default.get("".concat(this.baseUrl, "/api/openai/thread/").concat(this.threadId, "/runs"), {
                                signal: this.abortController.signal
                            })];
                    case 1:
                        runs = _a.sent();
                        if (runs.data.data.length > 0) {
                            inProgress = runs.data.data.filter(function (run) {
                                return run.status === 'in_progress';
                            });
                            // if there are in_progress runs we want to use the first one
                            if (inProgress.length > 0) {
                                this.runId = inProgress[0].id;
                                if (this.type === 'feedback' || this.type === 'meta') {
                                    this.pollStatus();
                                }
                                else if (this.type === 'scoring') {
                                    this.pollScoringStatus();
                                }
                                return [2 /*return*/];
                            }
                        }
                        data = {
                            assistant_id: this.assistantId,
                            additional_instructions: this.instructions
                        };
                        if (this.type === 'scoring') {
                            data.additional_instructions = 'Please score the following response using the evaluation rubric provided in the assistants instructions.';
                            data.force_function_calls = true;
                        }
                        return [4 /*yield*/, axios_1.default.post("".concat(this.baseUrl, "/api/openai/thread/").concat(this.threadId, "/run"), data)
                            // if resp.data.id is undefined throw an error
                        ];
                    case 2:
                        resp = _a.sent();
                        // if resp.data.id is undefined throw an error
                        if (!resp.data.id) {
                            throw new Error('Run ID is undefined');
                        }
                        this.runId = resp.data.id;
                        if (this.type === 'feedback' || this.type === 'meta') {
                            this.pollStatus();
                        }
                        else if (this.type === 'scoring') {
                            this.pollScoringStatus();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _a.sent();
                        if (e_3.name === 'AbortError') {
                            console.error('runAssistant was aborted');
                        }
                        else {
                            console.error(e_3);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Openai.prototype.pollStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                clearInterval(this.feedbackPollTimer);
                this.feedbackPollTimer = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                    var response, e_4;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 5, , 6]);
                                return [4 /*yield*/, axios_1.default.get("".concat(this.baseUrl, "/api/openai/thread/").concat(this.threadId, "/runs/").concat(this.runId), {
                                        signal: this.abortController.signal
                                    })];
                            case 1:
                                response = _a.sent();
                                this.runStatus = response.data.status;
                                if (!(response.data.status === 'completed')) return [3 /*break*/, 4];
                                clearInterval(this.feedbackPollTimer);
                                if (!!this.completedRunIds.includes(this.runId)) return [3 /*break*/, 3];
                                return [4 /*yield*/, this.getMessages()];
                            case 2:
                                _a.sent();
                                _a.label = 3;
                            case 3:
                                this.completedRunIds.push(this.runId);
                                _a.label = 4;
                            case 4: return [3 /*break*/, 6];
                            case 5:
                                e_4 = _a.sent();
                                if (e_4.name === 'AbortError') {
                                    console.error('pollStatus was aborted');
                                    this.killFeedbackPollTimer();
                                }
                                else {
                                    console.error(e_4);
                                }
                                return [3 /*break*/, 6];
                            case 6: return [2 /*return*/];
                        }
                    });
                }); }, 1000);
                return [2 /*return*/];
            });
        });
    };
    Openai.prototype.killFeedbackPollTimer = function () {
        // console.log('killing feedback poll timer')
        clearInterval(this.feedbackPollTimer);
    };
    Openai.prototype.pollScoringStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                clearInterval(this.scoringPollTimer);
                this.scoringPollTimer = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                    var response, functions, e_5;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 5, , 6]);
                                return [4 /*yield*/, axios_1.default.get("".concat(this.baseUrl, "/api/openai/thread/").concat(this.threadId, "/runs/").concat(this.runId), {
                                        signal: this.abortController.signal
                                    })];
                            case 1:
                                response = _a.sent();
                                if (response.data.status === 'requires_action') {
                                    functions = response.data.required_action.submit_tool_outputs.tool_calls.filter(function (tool_call) {
                                        return tool_call.type === 'function';
                                    });
                                    this.handleFunctionCalls(functions);
                                    this.killScoringPollTimer();
                                }
                                if (!(response.data.status === 'completed')) return [3 /*break*/, 4];
                                this.killScoringPollTimer();
                                if (!!this.completedRunIds.includes(this.runId)) return [3 /*break*/, 3];
                                return [4 /*yield*/, this.getMessages()];
                            case 2:
                                _a.sent();
                                _a.label = 3;
                            case 3:
                                this.completedRunIds.push(this.runId);
                                _a.label = 4;
                            case 4: return [3 /*break*/, 6];
                            case 5:
                                e_5 = _a.sent();
                                if (e_5.name === 'AbortError') {
                                    console.error('pollScoringStatus was aborted');
                                    this.killScoringPollTimer();
                                }
                                else {
                                    console.error(e_5);
                                }
                                return [3 /*break*/, 6];
                            case 6: return [2 /*return*/];
                        }
                    });
                }); }, 1000);
                return [2 /*return*/];
            });
        });
    };
    Openai.prototype.killScoringPollTimer = function () {
        // console.log('killing scoring poll timer')
        clearInterval(this.scoringPollTimer);
    };
    Openai.prototype.handleFunctionCalls = function (funcs) {
        // we only want to handle the function calls from
        // a scoring assistant once so just return if this
        // ends up getting called again in the event we get
        // more than one response with a requires_action status
        if (this.aborted || this.functionCallsHandled) {
            // console.log('aborting handleFunctionCalls')
            return;
        }
        if (this.logToConsole) {
            console.log('FUNCTION CALLS');
            console.log(funcs);
        }
        var grade = {};
        funcs.forEach(function (func) {
            var args = JSON.parse(func.function.arguments);
            Object.entries(args).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                grade[key] = value;
            });
        });
        this.grade = grade;
        var outputs = [];
        funcs.forEach(function (func) {
            outputs.push({
                tool_call_id: func.id,
                output: 'ok'
            });
        });
        this.submitFunctionOutputs(outputs, this.grade);
        this.grade['assistantId'] = this.assistantId;
        // @ts-ignore
        if (this.getScoreCallback) {
            // @ts-ignore
            if (this.grade['meter']) {
                // normalize this value since OpenAI randomly capitalizes it sometimes
                this.grade['meter'] = this.grade['meter'].toLowerCase();
            }
            // @ts-ignore
            this.getScoreCallback(this.grade);
        }
        this.functionCallsHandled = true;
    };
    Openai.prototype.submitFunctionOutputs = function () {
        return __awaiter(this, arguments, void 0, function (outputs, grade) {
            var data, e_6;
            if (outputs === void 0) { outputs = []; }
            if (grade === void 0) { grade = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = {
                            outputs: {
                                tool_outputs: outputs
                            },
                            grade: grade,
                            signal: this.abortController.signal
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        // @ts-ignore
                        (0, axios_retry_1.default)(axios_1.default, {
                            retries: 3, retryCondition: function () { return true; }, retryDelay: function (retryCount) {
                                return retryCount * 1000;
                            }
                        });
                        return [4 /*yield*/, axios_1.default.post("".concat(this.baseUrl, "/api/openai/thread/").concat(this.threadId, "/runs/").concat(this.runId), data)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.pollScoringStatus()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_6 = _a.sent();
                        if (e_6.name === 'AbortError') {
                            console.error('submitFunctionOutputs was aborted');
                        }
                        else {
                            console.error(e_6);
                        }
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Openai.prototype.getMessages = function () {
        return __awaiter(this, void 0, void 0, function () {
            var resp, messages, extractedText, e_7;
            var _this = this;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        // @ts-ignore
                        (0, axios_retry_1.default)(axios_1.default, {
                            retries: 3, retryCondition: function () { return true; }, retryDelay: function (retryCount) {
                                return retryCount * 1000;
                            }
                        });
                        return [4 /*yield*/, axios_1.default.get("".concat(this.baseUrl, "/api/openai/thread/").concat(this.threadId, "/messages"), {
                                signal: this.abortController.signal
                            })];
                    case 1:
                        resp = _c.sent();
                        messages = resp.data.data.map(function (message) {
                            var _a, _b;
                            var extractedText = _this.extractTextFromResponse((_b = (_a = message.content[0]) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b.value);
                            var m = {
                                role: message.role,
                                text: extractedText || ''
                            };
                            return m;
                        });
                        // reverse the messages so the most recent is at the bottom
                        messages.reverse();
                        extractedText = this.extractTextFromResponse((_b = (_a = resp.data.data[0].content[0]) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b.value);
                        this.feedback = extractedText || '';
                        // @ts-ignore
                        if (this.getMessagesCallback) {
                            // console.log('calling getMessagesCallback')
                            // @ts-ignore
                            this.getMessagesCallback(this, messages);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_7 = _c.sent();
                        if (e_7.name === 'AbortError') {
                            console.error('getMessages was aborted');
                        }
                        else {
                            console.error(e_7);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Openai.prototype.startStreaming = function () {
        return __awaiter(this, arguments, void 0, function (callbacks, forceFunctionCalls, toolOutputs, runId) {
            var paramData, params, url;
            var _this = this;
            if (callbacks === void 0) { callbacks = {}; }
            if (forceFunctionCalls === void 0) { forceFunctionCalls = false; }
            if (toolOutputs === void 0) { toolOutputs = null; }
            if (runId === void 0) { runId = null; }
            return __generator(this, function (_a) {
                paramData = {
                    assistant_id: this.assistantId,
                };
                if (forceFunctionCalls) {
                    paramData.force_function_calls = 'true';
                }
                if (toolOutputs) {
                    paramData.tool_outputs = JSON.stringify(toolOutputs);
                }
                if (runId) {
                    paramData.run_id = runId;
                }
                // @ts-ignore
                paramData.token = this.apiToken;
                params = new URLSearchParams(paramData);
                url = "".concat(this.baseUrl, "/api/openai/thread/").concat(this.threadId, "/run-stream?").concat(params.toString());
                this.eventSource = new eventsource_1.EventSource(url);
                // Handle different event types
                this.eventSource.addEventListener('message', function (event) {
                    try {
                        var data = void 0;
                        try {
                            if (event.data === '[DONE]') {
                                _this.stopStreaming();
                                return;
                            }
                            data = JSON.parse(event.data);
                        }
                        catch (parseError) {
                            console.warn('Failed to parse event data:', parseError);
                            // If it's not JSON, try using the raw data
                            data = event.data;
                        }
                        if (data.object === 'thread.message' && data.status === 'completed') {
                            if (callbacks.onComplete)
                                callbacks.onComplete(data.content);
                            _this.stopStreaming();
                        }
                        else if (data.object === 'thread.message.delta') {
                            if (callbacks.onDelta)
                                callbacks.onDelta(data.delta);
                        }
                        else if (data.object === 'thread.run' && data.status === 'requires_action') {
                            var grade = data.required_action.submit_tool_outputs.tool_calls[0].function.arguments;
                            grade = JSON.parse(grade);
                            grade = grade.meter;
                            if (callbacks.onRequiresAction)
                                callbacks.onRequiresAction({
                                    assistant_id: _this.assistantId,
                                    grade: grade,
                                    tool_call_id: data.required_action.submit_tool_outputs.tool_calls[0].id,
                                    run_id: data.id
                                });
                            _this.stopStreaming();
                        }
                    }
                    catch (error) {
                        console.error('Error processing SSE event:', error);
                        if (callbacks.onError)
                            callbacks.onError(error);
                        _this.stopStreaming();
                    }
                });
                this.eventSource.addEventListener('open', function (event) {
                    // console.log('SSE connection opened')
                    if (callbacks.onOpen)
                        callbacks.onOpen(event);
                });
                this.eventSource.addEventListener('error', function (error) {
                    console.error('SSE connection error:', error);
                    if (callbacks.onError)
                        callbacks.onError(error);
                    _this.stopStreaming();
                });
                this.eventSource.addEventListener('format', function (event) {
                    try {
                        var formatData = JSON.parse(event.data);
                        // console.log('Output format:', formatData.format);
                        // Store the format for use in other event handlers
                        _this.outputFormat = formatData.format;
                    }
                    catch (error) {
                        console.error('Error parsing format event:', error);
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    Openai.prototype.stopStreaming = function () {
        if (this.eventSource) {
            // console.log('Closing SSE connection')
            this.eventSource.close();
            this.eventSource = null;
        }
    };
    return Openai;
}());
exports.default = Openai;
